module.exports = __webpack_public_path__ + "img/logo__dark.0888f3c4.svg";